import React, { useState } from "react";
import { FaArrowRightLong } from "react-icons/fa6";
import { createNewSubscription } from "../../API/newsletterAPI";
import Swal from 'sweetalert2';

const NewsLetterSection = () => {

  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    const inputEmail = e.target.value;
    setEmail(inputEmail);

    if (!validateEmail(inputEmail)) {
      setError("Please enter a valid email address.");
    } else {
      setError("");
    }
  };

  const handleSubmit = async () => {
    if (error || !email) {
      setError("Please enter a valid email address.");
      return;
    }

    try {
      console.log("email", email)
      const response = await createNewSubscription(email);
      console.log("response", response)
      console.log(response)
          
                  if (response.success) {
                      Swal.fire({
                          icon: 'success',
                          title: 'Subscribe Successfully',
                          text: 'Your newsletter subscription successful!',
                      });
      
                      setEmail("");
                  } else {
                      Swal.fire({
                          icon: 'error',
                          title: 'Subscription Failed',
                          text: 'Failed subscription. Please try again.',
                      });
                  }
    } catch (err) {
      console.error(err);
      alert("Failed to subscribe. Please try again later.");
    }
  };

  return (
    <section className="relative w-full h-[600px] bg-newsletter bg-cover bg-no-repeat mt-[50px]">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-t from-[#F5E9D7]/50 to-[#93C572]/50 flex items-center justify-center">
            <div className="w-[80%] lg:w-[60%] xl:w-[50%] 2xl:w-[40%] h-[70%] flex flex-col items-center justify-center text-[#41220E]">
                <h1 className="font-playfair font-semibold text-5xl lg:text-7xl text-center my-5">Join Our Newsletter</h1>
                <p className="font-montserrat text-2xl lg:text-3xl text-center my-5">Get the newest updates and offers delivered right to your inbox!</p>
                <div className="w-[80%] flex relative">
                  <input
                    className="w-full h-[50px] bg-[#F5E9D7] border-solid border-2 border-[#714E16] rounded-[10px] px-[20px] pr-[50px] placeholder:italic placeholder:font-montserrat"
                    placeholder="Enter your email address"
                    value={email}
                    onChange={handleChange}
                  />
                  <button
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 text-[#41220E] text-[20px]"
                    onClick={handleSubmit}
                  >
                    <FaArrowRightLong />
                  </button>
                </div>
                <div className="w-[80%] py-1">
                  {error && <p style={{ color: "red" }}>{error}</p>}
                </div>
            </div>
        </div>
      
    </section>
  )
}

export default NewsLetterSection
